import React from 'react';
import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogContentTextProps,
} from '@mui/material';

import { TP_COLORS } from '../../../../constants';

const buttonProps: ButtonProps = {
  disableElevation: true,
  color: 'inherit',
  variant: 'contained',
  sx: {
    width: '90px',
    height: '45px',
    fontWeight: '600',
    backgroundColor: TP_COLORS.border.color1,
  },
};

const dialogContentTextProps: DialogContentTextProps = {
  fontWeight: '600',
  fontSize: '16px',
  textAlign: 'center',
  marginBottom: '10px',
};

export interface ILeadGenState {
  email: string;
  fullName: string;
  phoneNumber: string;
  country: string;
}

interface LoginAlertModalProps {
  open: boolean;
  onClose: () => void;
}

const LoginAlertModal: React.FC<LoginAlertModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          padding: { xs: '10px', sm: '30px' },
          borderRadius: '20px',
          maxWidth: '500px',
        },
      }}
    >
      <DialogContent>
        <DialogContentText {...dialogContentTextProps}>
          We have sent your login credentials to your email. Please sign in
          using those credentials for complete access of the platform
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', padding: '10px' }}>
        <Button {...buttonProps} onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginAlertModal;
